<script setup lang="ts">
import type LxcError from "~/core/models/LxcError.class";

defineProps<{
  isLoading?: boolean;
  error?: LxcError | null;
  title?: string;
}>();
</script>

<template>
  <lxc-card class="card-body h-full" shadow>
    <h4 v-if="title" class="text-gray-700 mb-6">
      {{ title }}
    </h4>

    <container-component
      :error="error"
      :is-loading="isLoading"
      :loader-size="16"
      :px="0"
      :py="0"
    >
      <slot />
    </container-component>
  </lxc-card>
</template>
